export const NoPage = () => {
  return <>NoPage</>;
};
